
/**
 * Handles the show submit form
 */
(function($) {
	$(document).ready(function() {
		// add strict url validator to parsley
		window.Parsley.addValidator('urlStrict', {
		  validate: function(value) {
				var regExp = /(https?:\/\/)(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#()?&//=]*)/;
				return regExp.test( value );
		  },
		  messages: {
	      en: 'Please provide a valid URL (must include http:// or https://)'
		  }
		})

		// Parsely Form Validation
		$(".parsely-form").parsley({
			errorClass: 'is-invalid text-danger',
			successClass: '',
			errorsWrapper: '<span class="form-text text-danger"></span>',
			errorTemplate: '<span></span>',
			trigger: 'change',
			requiredMessage: 'Required',
		});

		// Submit Form
		function isSubmitting(isSubmitting) {
			if (isSubmitting) {
				$('.btn-spinner').show();
				$('.btn-submit').attr('disabled', true);
			} else {
				$('.btn-spinner').hide();
				$('.btn-submit').attr('disabled', false);
			}
		};

		$('#venue').on('change', function() {
			if ($(this).val() === 'other' ) {
				$('.other-venue-info').show();
				$('#other-venue').attr('required', true);
				$('#other-venue-street-address').attr('required', true);
			} else {
				$('.other-venue-info').hide();
				$('#other-venue').attr('required', false);
				$('#other-venue-street-address').attr('required', false);
			}
		});

		$('.form-select').on('change', function() {
			if ( $(this).val().length ) {
				$(this).addClass('text-dark');
			}
		});

		$('#show-submit').submit(function(e) {
			e.preventDefault();
			isSubmitting(true);

			var $form = $(this);
			var formData = $form.serializeArray();

			$.post('/wp-json/showlist/v1/submit', formData)
				.done(function() {
					$('.submit-a-show').toggleClass('d-none');
					$('.submit-thank-you').toggleClass('d-none');
				})
				.fail(function() {
					$('.submit-a-show').toggleClass('d-none');
					$('.submit-error').toggleClass('d-none');
				});
		});
	});
})(jQuery);
